var FormsErrorStatusCodeEnum = /* @__PURE__ */ ((FormsErrorStatusCodeEnum2) => {
  FormsErrorStatusCodeEnum2["FORMS_GET_OPTIONS_NOT_FOUND_FIELD"] = "forms.getOptions.notFoundField";
  FormsErrorStatusCodeEnum2["FORMS_GET_OPTIONS_MISSING_DEPENDENT_FIELD_VALUES"] = "forms.getOptions.missingDependentFieldValues";
  FormsErrorStatusCodeEnum2["FORMS_GET_OPTIONS_NOT_FOUND_CATALOG_SCHEMA"] = "forms.getOptions.notFoundCatalogSchema";
  FormsErrorStatusCodeEnum2["FORMS_GET_OPTIONS_DEFAULT"] = "forms.getOptions.default";
  FormsErrorStatusCodeEnum2["FORMS_GET_ESTIMATE_NOT_FOUND"] = "forms.getEstimate.notFound";
  FormsErrorStatusCodeEnum2["FORMS_GET_ESTIMATE_DEFAULT"] = "forms.getEstimate.default";
  FormsErrorStatusCodeEnum2["FORMS_GET_REPORT_FAILED_CREATE_REPORT_REQUEST"] = "forms.getReport.failedCreateReportRequest";
  FormsErrorStatusCodeEnum2["FORMS_GET_REPORT_FAILED_GET_VEHICLE_REPORT"] = "forms.getReport.failedGetVehicleReport";
  FormsErrorStatusCodeEnum2["FORMS_GET_REPORT_DEFAULT"] = "forms.getReport.default";
  FormsErrorStatusCodeEnum2["FORMS_SUBMIT_NOT_FOUND_CURRENT_FORM_OR_STAGE"] = "forms.submit.notFoundCurrentFormOrStage";
  FormsErrorStatusCodeEnum2["FORMS_SUBMIT_NOT_FOUND_ACTION"] = "forms.submit.notFoundAction";
  FormsErrorStatusCodeEnum2["FORMS_SUBMIT_DEFAULT"] = "forms.submit.default";
  return FormsErrorStatusCodeEnum2;
})(FormsErrorStatusCodeEnum || {});
var StagesErrorStatusCodeEnum = /* @__PURE__ */ ((StagesErrorStatusCodeEnum2) => {
  StagesErrorStatusCodeEnum2["STAGES_GET_STAGES_FAILED_GET_STAGES"] = "stages.getStages.failedGetStages";
  StagesErrorStatusCodeEnum2["STAGES_GET_STAGES_DEFAULT"] = "stages.getStages.default";
  return StagesErrorStatusCodeEnum2;
})(StagesErrorStatusCodeEnum || {});
const ErrorStatusCode = {
  ...FormsErrorStatusCodeEnum,
  ...StagesErrorStatusCodeEnum
};
const ERROR_STATUS_CODE_MAP = {
  // FORMS
  [ErrorStatusCode.FORMS_GET_OPTIONS_NOT_FOUND_FIELD]: "Не удалось найти поле",
  [ErrorStatusCode.FORMS_GET_OPTIONS_MISSING_DEPENDENT_FIELD_VALUES]: "Отсутствуют значения у полей, от которых зависит поле",
  [ErrorStatusCode.FORMS_GET_OPTIONS_NOT_FOUND_CATALOG_SCHEMA]: "Не удалось получить список значений",
  [ErrorStatusCode.FORMS_GET_OPTIONS_DEFAULT]: "Ошибка при получении опции поля формы",
  [ErrorStatusCode.FORMS_GET_ESTIMATE_NOT_FOUND]: "Для редких, битых и новых машин не получится посчитать рыночную цену",
  [ErrorStatusCode.FORMS_GET_ESTIMATE_DEFAULT]: "Ошибка получения оценки",
  [ErrorStatusCode.FORMS_GET_REPORT_FAILED_CREATE_REPORT_REQUEST]: "Не удалось создать заявку на отчет по автомобилю",
  [ErrorStatusCode.FORMS_GET_REPORT_FAILED_GET_VEHICLE_REPORT]: "Не удалось получить отчет по автомобилю",
  [ErrorStatusCode.FORMS_GET_REPORT_DEFAULT]: "Ошибка при получении отчета по автомобилю",
  [ErrorStatusCode.FORMS_SUBMIT_NOT_FOUND_CURRENT_FORM_OR_STAGE]: "Не удалось найти текущую стадию и форму",
  [ErrorStatusCode.FORMS_SUBMIT_NOT_FOUND_ACTION]: "Не удалось найти обработчик для формы",
  [ErrorStatusCode.FORMS_SUBMIT_DEFAULT]: "Ошибка формы",
  // STAGES
  [ErrorStatusCode.STAGES_GET_STAGES_FAILED_GET_STAGES]: "Не удалось получить стадии",
  [ErrorStatusCode.STAGES_GET_STAGES_DEFAULT]: "Ошибка при получении стадии"
};
export {
  ERROR_STATUS_CODE_MAP,
  ErrorStatusCode,
  FormsErrorStatusCodeEnum,
  StagesErrorStatusCodeEnum
};
